export enum EurotaxRequestType {
    CATEGORY = 'CATEGORY',
    MAKE = 'MAKE',
    MODEL = 'MODEL',
    TYPE = 'TYPE',
    BODY = 'BODY',
    DOORS = 'DOORS',
    FUEL = 'FUEL',
    CAPACITY = 'CAPACITY',
    GEARBOX = 'GEARBOX',
}

export class EurotaxRequest {
    type: EurotaxRequestType;
    categoryId: number;
    year: number;
    makeId: number;
    modelId: number;
    bodyType: string;
    doorCount: number;
    fuelType: string;
    capacity: number;
    gearBoxType: string;
}

export class EurotaxValuation {
    valuation: Valuation;
}

export class Valuation {
    averageMileage: number;
    basePurchaseValue: number;
    baseSaleValue: number;
    baseSaleValueOut: number;
    valuationMode: string;
}
